import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TextArea } from '@telialt/common-text-area/src';

import { LEAD_TEST_IDS } from '../constants';
import { LeadFieldName } from '../model';

type Props = { initialValue?: string; helpText?: string };

export const CommentField: FC<Props> = ({ helpText, initialValue = '' }) => {
    const { t } = useTranslations();

    return (
        <TextArea
            label={t['content.lead.comment.label']}
            rows={2}
            defaultValue={initialValue}
            helperText={helpText}
            name={'comment' as LeadFieldName}
            dataTest={LEAD_TEST_IDS.FIELD_COMMENT}
        />
    );
};
